// extracted by mini-css-extract-plugin
export default {"anotherSaleBtn":"IconButtons_anotherSaleBtn__E9lsx","iconBtn":"IconButtons_iconBtn__0qzP4","addIcon":"IconButtons_addIcon__SIOeI"};